/**
 * Generic constraint for objects that have phoneNumberE164 and ownerId fields
 * Covers TelecomPhoneNumber, GlobalOptInOut, UpdatePhoneRequest, etc.
 */
export interface PhoneOwnerIdentifiable {
    phoneNumberE164: string | null;
    ownerId: number;
}

/**
 * Creates a unique identifier from ownerId and phoneNumberE164
 */
export const createPhoneId = <T extends PhoneOwnerIdentifiable>(item: T): string => {
    const phoneNumber = item.phoneNumberE164 || '';
    return `${item.ownerId}:${phoneNumber}`;
};

/**
 * Parses a phone ID back to ownerId and phoneNumberE164
 */
export const parsePhoneId = (id: string): { ownerId: number; phoneNumberE164: string } => {
    const [ownerIdStr, phoneNumberE164] = id.split(':');
    return {
        ownerId: parseInt(ownerIdStr, 10),
        phoneNumberE164: phoneNumberE164 || '',
    };
};
